import { Pow as PowScale } from '@antv/scale';
export const Pow = (options) => {
    return new PowScale(options);
};
Pow.props = {};
//# sourceMappingURL=pow.js.map